import { API_URL } from "../../constants";
import { axiosInstance } from "../_base/axios.instance";

export async function addPost({ postRequest }) {
  const response = await axiosInstance.post(
    `${API_URL}/posts/add`,
    postRequest,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
}
